import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.iterator.js";
import { Core } from "@faire/design-tokens";
import { Column, Grid, Row } from "@faire/web/slate/Layout";
import { LoadingSkeleton } from "@faire/web/slate/LoadingSkeleton";
import { Spacer, getSpacing } from "@faire/web/slate/spacing";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import React from "react";
import styled from "styled-components";
import { BRAND_ORDERS_PAGE_SIZE } from "../consts";
import { useOrderItemCardGrid } from "../hooks/useOrderItemCardGrid";
export var GridOrderItemCardsLoadingSkeleton = function GridOrderItemCardsLoadingSkeleton() {
  var _useOrderItemCardGrid = useOrderItemCardGrid(),
    gap = _useOrderItemCardGrid.gap,
    itemsPerRow = _useOrderItemCardGrid.itemsPerRow;
  var _useViewport = useViewport(),
    isMobile = _useViewport.isMobile;
  return /*#__PURE__*/React.createElement(Grid, {
    gap: gap,
    columns: itemsPerRow,
    style: {
      width: "100%"
    },
    columnTemplate: function columnTemplate(columns) {
      return isMobile ? "repeat(".concat(columns, ", minmax(150px, 1fr))") : "repeat(".concat(columns, ", 1fr)");
    }
  }, Array.from({
    length: BRAND_ORDERS_PAGE_SIZE
  }).map(function (_, index) {
    return /*#__PURE__*/React.createElement(OrderItemCardLoadingSkeleton, {
      key: index
    });
  }));
};
var OrderItemCardLoadingSkeleton = function OrderItemCardLoadingSkeleton() {
  return /*#__PURE__*/React.createElement(OrderItemCardWrapper, null, /*#__PURE__*/React.createElement(LoadingSkeleton, {
    height: "100px",
    width: "100px"
  }), /*#__PURE__*/React.createElement(Spacer, {
    width: "3x"
  }), /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(LoadingSkeleton, {
    height: "25px",
    width: "100px"
  }), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LoadingSkeleton, {
    height: "12px",
    width: "200px"
  }), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LoadingSkeleton, {
    height: "12px",
    width: "200px"
  }), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LoadingSkeleton, {
    height: "12px",
    width: "200px"
  })));
};
var OrderItemCardWrapper = styled(Row).attrs({
  align: "center"
}).withConfig({
  displayName: "GridOrderItemCardsLoadingSkeleton__OrderItemCardWrapper"
})(["border:1px solid ", ";border-radius:4px;padding:", ";min-height:120px;min-width:326px;height:auto;width:100%;cursor:pointer;"], Core.border.muted, getSpacing("2x"));